import {Injectable} from '@angular/core'

@Injectable()

export class NetInfoService {


  tabla = 'rest_net_data_info';
  data;

  constructor() {

    this.data = JSON.parse(localStorage.getItem(this.tabla)) || {status: true, blockscreen: false};

  }


  get(key) {

    return this.data && (key in this.data) ? this.data[key] : false;

  }


  set(key, value) {

    this.data[key] = value;
    localStorage.setItem(this.tabla, JSON.stringify(this.data));

    return this.data[key];

  }

  delete() {

    localStorage.removeItem(this.tabla);
    return this.data = null;

  }


}



// WEBPACK FOOTER //
// ./src/services/NetInfoService.ts